import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';

import { type LqaSuggestionRequest, type LqaSuggestionResponse } from './types';

const lqaSuggestionsApi = createApi({
    reducerPath: 'lokaliseInternal_lqa_suggestions',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getLqaSuggestions: builder.query<LqaSuggestionResponse | undefined, LqaSuggestionRequest>({
            query: ({ translationId }) => ({
                url: `/lqa-suggestions/${translationId}`,
                method: 'GET',
            }),
            transformResponse: (response: LqaSuggestionResponse | null) => response ?? undefined,
            forceRefetch: () => true,
        }),
    }),
});

export const { useGetLqaSuggestionsQuery } = lqaSuggestionsApi;
export * from './types';

export default lqaSuggestionsApi;
